import { getVersionedCallbackUrl, redirectToWebform } from "@repo/shared-utils/common-utils";
import type { SSORedirectHandler } from "../types/SSO.types";

export const cartHandler: SSORedirectHandler = async (data) => {
  const callbackUrl = await getVersionedCallbackUrl(data.mapping);
  const formData = {
    cart: true,
  };
  redirectToWebform(callbackUrl.toString(), formData);
};
